var React = require('react');

function Search12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 6.01954 9.69485 6.96781 9.17089 7.75846L12 10.586L10.587 12L7.75846 9.17089C6.96781 9.69485 6.01954 10 5 10C2.23858 10 0 7.76142 0 5ZM8 5C8 3.34315 6.65685 2 5 2C3.34315 2 2 3.34315 2 5C2 6.65685 3.34315 8 5 8C6.65685 8 8 6.65685 8 5Z","fill":"currentColor"}));
}

Search12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Search12;

Search12.default = Search12;
